import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  House,
  MapPin,
  CarProfile,
  SquaresFour,
  Wallet as WalletIcon,
  User,
} from "@phosphor-icons/react";

const CUSTOMER_TABS = [
  { to: "/app", labelKey: "nav.home", icon: House },
  { to: "/app/ride", labelKey: "nav.book", icon: MapPin },
  { to: "/app/services", labelKey: "nav.services", icon: SquaresFour },
  { to: "/app/wallet", labelKey: "nav.payments", icon: WalletIcon },
  { to: "/app/profile", labelKey: "nav.profile", icon: User },
];

const DRIVER_TABS = [
  { to: "/driver", labelKey: "nav.home", icon: House },
  { to: "/driver/history", labelKey: "nav.rides", icon: CarProfile },
  { to: "/driver/wallet", labelKey: "nav.earnings", icon: WalletIcon },
  { to: "/driver/profile", labelKey: "nav.profile", icon: User },
];

const COURIER_TABS = [
  { to: "/courier", labelKey: "nav.home", icon: House },
  { to: "/courier/history", labelKey: "nav.rides", icon: CarProfile },
  { to: "/courier/wallet", labelKey: "nav.earnings", icon: WalletIcon },
  { to: "/courier/profile", labelKey: "nav.profile", icon: User },
];

export default function BottomNav({ role = "customer" }) {
  const { t } = useTranslation();
  const tabs = role === "driver" ? DRIVER_TABS : role === "courier" ? COURIER_TABS : CUSTOMER_TABS;
  return (
    <nav
      className="bottom-nav-fixed fixed inset-x-0 bottom-0 z-[900] mx-auto w-full max-w-[540px]"
      data-testid="bottom-nav"
    >
      <div className="bottom-nav-shell glass-strong glow-inset">
        <div className="bottom-nav-grid grid items-center gap-1" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.to === "/app" || tab.to === "/driver"}
              className={({ isActive }) =>
                `bottom-nav-link flex min-w-0 flex-col items-center justify-center gap-0.5 rounded-full px-1 py-1.5 text-[8px] font-bold uppercase tracking-normal press-down min-[390px]:text-[9px] min-[390px]:tracking-widest ${
                  isActive
                    ? "bg-primary text-primary-foreground glow-blue"
                    : "text-muted-foreground hover:text-foreground"
                }`
              }
              data-testid={`tab-${tab.to.replaceAll("/", "-")}`}
            >
              <tab.icon size={20} weight="bold" />
              <span className="max-w-full truncate">{t(tab.labelKey)}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}
